// Generated by CoffeeScript 2.7.0
var POPOVER_SIZE_MAP, capturedBackdrop;

({capturedBackdrop} = Skylark.Helpers.App);

POPOVER_SIZE_MAP = {
  small: 160,
  default: 200,
  normal: 240,
  large: 320,
  larger: 360
};

export var Popover = class Popover {
  constructor(element, options = {}) {
    this.options = _.pick(options, 'stop', 'beforeOpenFunc', 'beforeCloseFunc', 'type', 'size');
    this.width = POPOVER_SIZE_MAP.default;
    this.isOpen = false;
    this.element = DomMaster.wrap(element);
    this.isHCenterPositionAtFirst = this.element.containsClass('h-center');
    if (this.options.type) {
      this.element.addClass(this.options.type);
    }
    if (this.options.size) {
      this.element.addClass(`popover-${this.options.size}`);
      this.width = POPOVER_SIZE_MAP[this.options.size];
    }
    this.trigger_node = this.element.find('.trigger').node;
    this.caret_node = this.element.find('.caret').node;
    this.content_node = this.element.find('.content').node;
    this._init();
  }

  open() {
    var base;
    if (this.isOpen) {
      return;
    }
    if (typeof (base = this.options).beforeOpenFunc === "function") {
      base.beforeOpenFunc(this);
    }
    this.element.node.addClass('open');
    this.__calculatePosition();
    this.__enableBackdrop();
    return this.isOpen = true;
  }

  close() {
    var base;
    if (!this.isOpen) {
      return;
    }
    if (typeof (base = this.options).beforeCloseFunc === "function") {
      base.beforeCloseFunc(this);
    }
    this.element.node.removeClass('open');
    return this.isOpen = false;
  }

  switchSize(size) {
    if (this.options.size) {
      this.element.removeClass(`popover-${this.options.size}`);
    }
    _.extend(this.options, {
      size: size
    });
    this.element.addClass(`popover-${size}`);
    this.width = POPOVER_SIZE_MAP[this.options.size];
    return this.__calculatePosition();
  }

  _init() {
    this.trigger_node.addEventListener('click', (event) => {
      if (this.options.stop) {
        event.stopPropagation();
      }
      if (this.isOpen) {
        return this.close();
      } else {
        return this.open();
      }
    }, false);
    return this.element.node.proxy('click', '.js-popover-close', (event) => {
      return this.close();
    }, false);
  }

  _backdrop() {
    return this.close();
  }

  __calculatePosition() {
    var bottom_enough, buffer_width, content_client_rect, content_left, offsetX, scrollable_container, scrollable_container_client_rect, top_enough, trigger_client_rect;
    if (this.isHCenterPositionAtFirst) {
      this.element.addClass('h-center');
    }
    this.__resetPosition();
    buffer_width = 10;
    scrollable_container = DomMaster.getScrollableContainer(this.trigger_node);
    scrollable_container_client_rect = scrollable_container.getBoundingClientRect();
    trigger_client_rect = this.trigger_node.getBoundingClientRect();
    content_client_rect = this.content_node.getBoundingClientRect();
    top_enough = trigger_client_rect.top - scrollable_container_client_rect.top > content_client_rect.height + buffer_width;
    bottom_enough = scrollable_container_client_rect.bottom - trigger_client_rect.bottom > content_client_rect.height + buffer_width;
    if (this.element.containsClass('top')) {
      if (!top_enough && bottom_enough) {
        this.element.removeClass('top');
        this.element.addClass('bottom');
      }
    } else {
      if (!bottom_enough && top_enough) {
        this.element.removeClass('bottom');
        this.element.addClass('top');
      }
    }
    if (this.element.containsClass('h-center')) {
      if (scrollable_container_client_rect.right < content_client_rect.right + buffer_width) {
        this.element.removeClass('h-center');
        offsetX = trigger_client_rect.left - (scrollable_container_client_rect.right - buffer_width - this.width);
        this.content_node.style.left = -offsetX + 'px';
        if (this.caret_node) {
          this.caret_node.style.left = (offsetX + trigger_client_rect.width / 2 - 6) + 'px';
        }
      }
      if (scrollable_container_client_rect.left > content_client_rect.left - buffer_width) {
        this.element.removeClass('h-center');
        content_left = trigger_client_rect.left - scrollable_container_client_rect.left;
        offsetX = content_left - buffer_width;
        this.content_node.style.left = -offsetX + 'px';
        if (this.caret_node) {
          return this.caret_node.style.left = (offsetX + trigger_client_rect.width / 2 - 6) + 'px';
        }
      }
    }
  }

  __resetPosition() {
    var ref;
    this.content_node.style = null;
    return (ref = this.caret_node) != null ? ref.style = null : void 0;
  }

  __enableBackdrop() {
    return capturedBackdrop((event) => {
      if (this.element.node.contains(event.target)) {
        return {
          force_clean: false
        };
      } else {
        return this._backdrop();
      }
    }, this.content);
  }

};

export var ConfirmPopover = class ConfirmPopover extends Popover {
  constructor(element, options = {}) {
    _.extend(options, {
      type: 'confirm',
      size: 'large'
    });
    super(element, options);
    this.options = _.extend(this.options, _.pick(options, 'confirmFunc', 'dismissFunc'));
    this.confirm_node = this.element.find('.js-popover-confirm').node;
    if (this.confirm_node) {
      this.confirm_node.addEventListener('click', (event) => {
        var base;
        this.close();
        return typeof (base = this.options).confirmFunc === "function" ? base.confirmFunc(this) : void 0;
      }, false);
    }
    this.element.node.proxy('click', '.js-popover-dismiss', (event) => {
      var base;
      this.close();
      return typeof (base = this.options).dismissFunc === "function" ? base.dismissFunc(this) : void 0;
    }, false);
  }

  _backdrop() {
    var base;
    this.close();
    return typeof (base = this.options).dismissFunc === "function" ? base.dismissFunc(this) : void 0;
  }

};

export var PromptPopover = class PromptPopover extends Popover {
  constructor(element, options = {}) {
    _.extend(options, {
      type: 'prompt'
    });
    super(element, options);
    this.options = _.extend(this.options, _.pick(options, 'confirmFunc', 'dismissFunc'));
    this.confirm_node = this.element.find('.js-popover-confirm').node;
    this.prompt_input_el = this.element.find('.js-popover-prompt-input');
    if (this.confirm_node) {
      this.confirm_node.addEventListener('click', (event) => {
        this.close();
        if (this.prompt_input_el.isPresent() && (this.options.confirmFunc != null)) {
          return this.options.confirmFunc(this, this.prompt_input_el.node.value);
        } else if (this.options.confirmFunc != null) {
          return this.options.confirmFunc(this);
        }
      }, false);
    }
    this.element.node.proxy('click', '.js-popover-dismiss', (event) => {
      var base;
      this.close();
      return typeof (base = this.options).dismissFunc === "function" ? base.dismissFunc(this) : void 0;
    }, false);
  }

  _backdrop() {
    var base;
    this.close();
    return typeof (base = this.options).dismissFunc === "function" ? base.dismissFunc(this) : void 0;
  }

};

export default Popover;
